/* eslint-disable */

// These functions are pure copy-paste, coming from "product/base.js" in SFRA.

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

const kleepTrackingEndpoints = {
    createSession: $('.js-kleep-tracking-create-session').val()
};

/**
 * Retrieves user session-related data and sends it to the session API.
 */
async function createSession(kleepUserId, isPDP) {
    try {
        let isPDP = $('.kleep-button').length > 0;
        const userReference = kleepUserId;
        const measureReference = null;
        const customerReference = null;
        const retailerDomain = window.location.hostname;
        const languageCode = navigator.language || 'en';
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const sessionData = {
            user_reference: userReference,
            retailer_domain: retailerDomain,
            language_code: languageCode,
            location_timezone: timezone,
            measure_reference: measureReference,
            customer_reference: customerReference,
            device: {
                type: getDeviceType(),
                name: navigator.userAgent
            },
            browser: {
                browser_type: getBrowserName(),
                browser_lang: languageCode
            },
            os: {
                name: getOS(),
                version: navigator.appVersion
            },
            screen: {
                height: screen.height,
                width: screen.width
            },
            kleepUserId: kleepUserId
        };

        const response = await fetch(kleepTrackingEndpoints.createSession, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(sessionData)
        });

        if (!response.ok) {
            throw new Error('Failed to create user session');
        }

        const responseData = await response.json();
        kleepSession = responseData.result.data.session_uuid;
        kleepUserId = responseData.result.data.userId;
        localStorage.setItem('kleep_user_uuid', kleepUserId);
        sessionStorage.setItem("kleep_session_uuid", kleepSession);
        if(isPDP){
            //sendKleepUUIDsToIframes(kleepSession, kleepUserId);
        }

    } catch (error) {
        console.warn('[Kleep] Error in createUserSession:', error);
    }
}

function sendKleepUUIDsToIframes(kleepSession, kleepUserId) {
    if (!kleepSession || !kleepUserId) return;
  
    const payload = {
      name: "kleep_send_uuids",
      values: {
        kleep_session_uuid: kleepSession,
        kleep_user_uuid: kleepUserId
      }
    };
  
    const iframes = document.querySelectorAll(
      'iframe[src*="drawer.kleep.ai"], iframe[src*="products.kleep.ai"]'
    );
  
    const post = (iframe) => {
      try {
        const origin = new URL(iframe.src).origin; // e.g. https://drawer.kleep.ai
        iframe.contentWindow && iframe.contentWindow.postMessage(payload, origin);
      } catch (_) {}
    };
  
    iframes.forEach((iframe) => {
      post(iframe); // try now
      iframe.addEventListener("load", () => post(iframe), { once: true });
      let n = 0, t = setInterval(() => { post(iframe); if (++n >= 3) clearInterval(t); }, 350);
    });
  }

/**
 * Detects the device type (mobile, tablet, or desktop)
 * @returns {string} Device type
 */
function getDeviceType() {
    const ua = navigator.userAgent;
    if (/mobile/i.test(ua)) return 'mobile';
    if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
    return 'desktop';
}

/**
 * Detects the user's browser
 * @returns {string} Browser name
 */
function getBrowserName() {
    const ua = navigator.userAgent;
    if (ua.indexOf('Chrome') !== -1) return 'Chrome';
    if (ua.indexOf('Firefox') !== -1) return 'Firefox';
    if (ua.indexOf('Safari') !== -1) return 'Safari';
    if (ua.indexOf('Edge') !== -1) return 'Edge';
    if (ua.indexOf('Opera') !== -1 || ua.indexOf('OPR') !== -1) return 'Opera';
    if (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident') !== -1) return 'IE';
    return 'Unknown';
}

/**
 * Detects the user's operating system
 * @returns {string} OS name
 */
function getOS() {
    const ua = navigator.userAgent;
    if (ua.indexOf('Win') !== -1) return 'Windows';
    if (ua.indexOf('Mac') !== -1) return 'MacOS';
    if (ua.indexOf('Linux') !== -1) return 'Linux';
    if (/android/i.test(ua)) return 'Android';
    if (/iphone|ipad|ipod/i.test(ua)) return 'iOS';
    return 'Unknown';
}

module.exports = {
    handlePostCartAdd: handlePostCartAdd,
    getAddToCartUrl: getAddToCartUrl,
    createSession: createSession,
    sendKleepUUIDsToIframes: sendKleepUUIDsToIframes
};